<template>
  <header class="HeaderTop w-bg">
    <div class="bg-f">
      <div class="w-h">
        <div class="logo">
          <img src="../images/logo_klm_270.png"/>
          <div class="title-right-text-mode" v-show="local">
            <h2>锦龙名车中心</h2>
            <span>Luxury car：<em>KLM</em></span>
          </div>
        </div>
        <div class="region">
          <i class="iconfont icon-dingwei"></i><span @click="cook(2)" :class=" position == 2 ? 'current' : ''">深圳</span> | 
          <span @click="cook(1)" :class=" position == 1 ? 'current' : ''">广州</span>
          <!-- <div class="region-list">
            <ul>
              <li>深圳</li>
              <li>广州</li>
            </ul>
          </div> -->
        </div>
      </div>
    </div>
    <div class="bg-0">
      <div class="w">
        <div class="title">
          <div class="title-header"  v-show="!local">
            <!-- <div class="title-logo">
              <img src="../images/logo_klm_270.png"/>
            </div> -->
            <!-- <div class="title-search">
              <input class="text" name="title" type="text"/>
              <input class="submit" type="submit" value="搜索"/>
            </div> -->
            <div class="title-right-text">
              <div class="h">
                <h2>锦龙汽车集团</h2>
                <span>Luxury car：<em>KLM</em></span>
              </div>
              <!-- <ol>
                <li>誠信</li>
                <li>責任</li>
                <li>優質</li>
              </ol> -->
            </div>
          </div>
          <!-- 导航栏 -->
          <nav>
            <router-link class="first-level " to="/yscindex">商店首页</router-link>
            <router-link class="first-level" :class="{'router-link-active' :'/salecar/subsalecar/'+id === $route.path}" to="/salecar">在售车源</router-link>
            <router-link class="first-level " to="/assessment">在线评价</router-link>
            <router-link class="first-level " to="/sellingcar">我要卖车</router-link>
            <router-link class="first-level " to="/substitutioncar">我要换车</router-link>
            <router-link class="first-level " to="/aboutdesign">联系我们</router-link>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import PubSub from 'pubsub-js'
import Cookies from 'js-cookie'

export default {
  name: 'HeaderTop',
  data () {
    return {
      local: false,
      screenWidth: document.body.clientWidth,
      id: '',
      position: Cookies.get('position') || 2
    }
  },
  methods: {
    cook(ids) {
      // console.log('position', ids, { domain: '172.20.60.100' })
      Cookies.set('position', ids)
      location.reload()
    },
    WindowScreenWidth(){
      const that = this
      window.screenWidth = document.body.clientWidth
      that.screenWidth = window.screenWidth
      console.log('window1', window.screenWidth)
      console.log('window2', document.body.clientWidth)
      if(that.screenWidth < 656){
        that.local = true
      } else {
        that.local = false
      }
    },
    goodid(){
      PubSub.subscribe('id', (msg, id) => {
      this.id = id
    })
    }
  },
  mounted () {
    this.goodid()
    const that = this
    this.WindowScreenWidth()
    window.onresize = () => {
      window.screenWidth = document.body.clientWidth
      that.screenWidth = window.screenWidth      
      if(that.screenWidth < 656){
        that.local = true
      } else {
        that.local = false
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../css-styl/mixins.styl'

  //头部响应式
  @media screen and (min-width: 869px) and (max-width: 999px) 
    .HeaderTop .bg-0 .title nav .first-level
      padding 10px 16px !important
  @media screen and (min-width: 800px) and (max-width: 868px) 
    .HeaderTop .bg-0 .title nav .first-level
      padding 6px 10px !important
    .HeaderTop .bg-0 .title .title-header .title-right-text .h
      h2
        font-size 27px!important
  @media screen and (min-width: 787px) and (max-width: 799px)     
    .HeaderTop .bg-f .logo   
      text-indent 10px !important
    .HeaderTop .bg-0 .title .title-header
      padding 12px 0 !important
    .HeaderTop .bg-0 .title nav 
      padding 12px 0 !important
      .first-level
        padding 6px 10px !important
    .HeaderTop .bg-0 .title .title-header .title-right-text .h
      padding 0 0 0 20px !important
      h2
        font-size 26px!important
  @media screen and (min-width: 660px) and (max-width: 786px) 
    .HeaderTop .bg-f .logo   
      text-indent 10px !important
    .HeaderTop .bg-0 .title .title-header
      padding 12px 0 !important
    .HeaderTop .bg-0 .title nav
      padding 12px 0 !important 
      .first-level
        padding 6px 1% !important
    .HeaderTop .bg-0 .title .title-header .title-right-text .h
      padding 0 0 0 10px !important 
      h2
        font-size 25px!important
  @media screen and (min-width: 0px) and (max-width: 659px)
    .HeaderTop .bg-0 .title .title-header
      width 100% !important
      padding 12px 0 !important
    .HeaderTop .bg-0 .title nav
      width 100% !important
      height 30px !important
      line-height 30px !important
      padding 10px 0 !important
      .first-level
        float left !important
        padding 6px 0 !important
    .HeaderTop .bg-f .logo
      width 80% !important
      text-indent 0 !important
      margin-left 0 !important
      img
        margin-left 10px
        display inline-block
    .HeaderTop .bg-f .region
      width 20% !important
  @media screen and (min-width: 0px) and (max-width: 419px)
    .HeaderTop .bg-0 .title nav
      padding 0 !important
      float none !important
      display block !important
      .first-level
        width 33.33% !important
        float left !important
    .HeaderTop .bg-f 
      .logo
        padding 20px 0 !important
      .region
        padding 25px 0 !important
  @media screen and (min-width: 0px) and (max-width: 352px)
    .HeaderTop .bg-f 
      .logo
        img
          display none !important
  .HeaderTop
    overflow hidden
    .w-h
      max-width 1200px
      margin 0 auto
    .bg-f
      font-size 16px
      width 100%
      // background #e0e0e0
      border-bottom 1px solid #e0e0e0
      box-shadow 0px 1px 2px #eee
      .logo
        width 50%
        text-indent 40px
        float left
        padding 5px 0
        img 
          height 38px
        .title-right-text-mode
          display inline-block
          margin-left 10px
          h2
            width 100%
            font-size 20px
            font-family "MB", "Hiragino Sans GB"
            font-weight 600 !important
            text-align left 
            letter-spacing 1px
            color #000
            display block
            vertical-align super
          span
            width 100%
            font-family "ML"
            font-size 16px
            font-weight 600 !important
            // color #af0426
            color red
            display block
            text-indent 2px
            text-align left 
            em
              font-weight 600 !important
      .region
        width 50%
        height 30px
        line-height 30px
        text-align right
        padding 10px 0
        float right
        position relative
        // .region-list
        //   background #fff
        //   padding 0 8px
        //   border-bottom 1px solid #e5e5e5
        //   // box-shadow 0px 0px 6px #000
        //   position absolute
        //   z-index 999
        //   top  46px 
        //   right 0
        //   ul
        //     li
        //       float left
        //       padding 2px

        span
          // color #221814
          color #999
          margin-right 10px
          cursor pointer
          &:nth-of-type(1)
            margin-right 0
            margin-left 10px
          &.current
            color #f00
            text-decoration underline
        i
          padding-right 2px
          color #d81e06
    .bg-0
      width 100%
      overflow hidden
      background #040404
      .title
        // padding-top 30px
        overflow hidden
        background #040404
        .title-header
          width 30%
          overflow hidden
          // padding-bottom 20px
          float left
          padding 20px 0px
          // .title-logo
          //   width 30%
          //   float left
          //   text-align center
          //   img
          //     width 180px
          // .title-search
          //   width 43%
          //   float left
          //   text-align center
          //   margin-top 12px
          //   .text
          //     mix-width 160px
          //     width 220px
          //     height 30px
          //     border 2px solid #ccc
          //     border-radius 2px;
          //   .submit
          //     width 64px
          //     height 34px
          //     border-radius 2px;
          //     background #d81e06
          //     color #fff
          .title-right-text
            width 100%
            font-size 16px
            text-align left
            float left
            .h
              padding 0 0px 0 40px
              h2
                width 100%
                font-size 30px
                font-family "MB", "Hiragino Sans GB"
                // font-weight 600 !important
                text-align left 
                letter-spacing 6px
                color #fff
                display block
                vertical-align super
              span
                width 100%
                font-family "BL"
                font-size 20px
                font-weight 600 !important
                margin-top 0
                // color #af0426
                color red
                display block
                text-indent 2px
                em
                  font-weight 600 !important
            // ol
            //   color #fff
            //   letter-spacing 1px
            //   display inline-block
            //   line-height 20px
            //   padding  0 20px 0 14px
            //   border-left 2px solid #fff
        nav
          width 70%
          height 44px
          font-family "ML" 
          font-size 16px
          line-height 44px
          text-align center 
          font-weight 600
          // background #464646
          background #000
          display inline-block
          float right
          padding 20px 0px 20px 0
          .first-level
            width 16.6%
            font-weight 600
            text-align center
            padding 10px 24px
            color #fff
          // .first-level-current
          //   padding 4px 40px
          //   top 10px
          //   color #000
          //   background #fff
</style>



// WEBPACK FOOTER //
// src/components/HeaderTop.vue